import { apiRequest } from './apiService';

// Fetch all sales quotes
export const fetchSalesQuotes = async () => {
  return await apiRequest('/crm/sales-quotes', 'GET');
};

// Create a new sales quote
export const createQuote = async (formData: FormData) => {
  return await apiRequest('/crm/crm-sales-quotes', 'POST', formData);
};

// Fetch a single sales quote by ID
export const fetchQuoteById = async (quote_id: string) => {
  return await apiRequest(`/crm/sales-quotes/${quote_id}`, 'GET');
};

// Delete a quote
export const deleteQuote = async (quote_id: string) => {
  return await apiRequest(`/crm/sales-quotes/${quote_id}`, 'DELETE');
};
